/**
 * A helper function to throw consistent error messages
 */
export function transactionError(errorTitle, errorMessage, detailsTitle, details) {
    throw new Error(`TRANSACTION-ERROR/${errorTitle.toUpperCase()}: ${errorMessage.toLowerCase()} / ${detailsTitle.toLowerCase()}: ${details.toLowerCase()}`);
}
